/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";

const requiredPropsCheck = (title, titleKey) => {
  if (!title && !titleKey) {
    return new Error('One of "title" or "titleKey" props is required by SEO component.');
  }
};

const SEO = ({ title, titleKey, description, descriptionKey, imageUrl, lang, meta, intl }) => {
  requiredPropsCheck(title, titleKey);

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            author
          }
        }
      }
    `
  );
  const translatedTitle = title || intl.formatMessage({ id: titleKey });
  const translatedDescription = description || intl.formatMessage({ id: descriptionKey });

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={translatedTitle}
      titleTemplate={`${site.siteMetadata.title} | %s`}
      meta={[
        {
          name: `description`,
          content: translatedDescription,
        },
        {
          property: `og:title`,
          content: translatedTitle,
        },
        {
          property: `og:translatedDescription`,
          content: translatedDescription,
        },
        {
          property: `og:image`,
          content: imageUrl,
        },
        {
          property: `og:image:alt`,
          content: translatedDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: translatedTitle,
        },
        {
          name: `twitter:description`,
          content: translatedDescription,
        },
      ].concat(meta)}
    />
  );
};

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
};

export default injectIntl(SEO);
